import React from "react";
import {
  Box,
  Toolbar,
  Typography,
  AppBar,
  makeStyles,
  Tooltip,
  Button,
} from "@material-ui/core";
import HeaderSpeedDial from "./components/HeaderSpeedDial";
import Notifications from "../notifications";
import {
  updateRequestHelpVisiblity,
} from "../../components/common/StoreCommon";

export default function Header(props) {
  const classes = useStyles();
  const actions = props.actions || [];
  const selectedName = actions
    .map((action) => (action.selected ? action.name : ""))
    .join("");
  
  return (
    <AppBar position="static" className={classes.appBar} elevation={0}>
      <Toolbar>
        <Box>
          {props.leading ? (
            props.leading
          ) : (
            <HeaderSpeedDial actions={actions} />
          )}
        </Box>
        {selectedName ? (
          <Typography variant="subtitle1" className={classes.title}>
            {selectedName}
          </Typography>
        ) : null}
        <Box style={{ marginLeft: 20 }}>{props.additional}</Box>
        <Box
          style={{ marginLeft: "auto", display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          {props.beforeSos ? (
            <Box style={{ display: "flex", alignItems: "center", marginRight: 4 }}>
              {props.beforeSos}
            </Box>
          ) : null}
          <Tooltip title="New SOS message">
            <Button
              onClick={() => updateRequestHelpVisiblity(true)}
              style={{
                borderRadius: 10,
              }}
            >
              <Typography variant="h6" style={{ color: "red" }}>
                SOS
              </Typography>
            </Button>
          </Tooltip>
          <Notifications />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "white",
    boxShadow: "none",
    maxHeight: 64,
  },
  title: {
    color: "rgb(135, 131, 131)",
    marginLeft: theme.spacing(3),
  },
  flipHorizontal: {
    transform: "scaleX(-1)",
  },
  sidebarPositionIcon: {
    [theme.breakpoints.only("xs")]: {
      display: "none",
    },
  },
}));
